export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const INIT_USER = 'GET_USER';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
